// theme.tsx
// MUIテーマの一元定義ファイル
// - カラーパレット・タイポグラフィ・コンポーネントスタイルを統一管理する
import { createTheme } from '@mui/material/styles';
import { CSSObject } from "@mui/system";
import '@mui/material/Chip';

// カスタムパレット・タイポグラフィ・Chipバリアントの型定義を拡張する
declare module '@mui/material/styles' {
   interface Palette {
     custom: {
       lightBlue: string;
       lightGreen: string;
       lightPink: string;
       lightOrange: string;
       lightRed: string;
       bluePinkGradient: string;
       lightbluePinkGradient: string;
       bluePinkGradient2:string;
       blue: string;
       gray:string;
     };
   }
 
   interface PaletteOptions {
     custom?: {
       lightBlue?: string;
       lightGreen?: string;
       lightPink?: string;
       lightOrange?: string;
       lightRed?: string;
       bluePinkGradient?: string;
       lightbluePinkGradient?: string;
       bluePinkGradient2?:string;
       blue?: string;
       gray?:string;
     };
   }

   interface TypographyVariants {
    buttonMedium: CSSObject;
    buttonLarge: CSSObject;
  }

  // TypographyVariantsOptions も拡張
  interface TypographyVariantsOptions {
    buttonMedium?: CSSObject;
    buttonLarge?: CSSObject;
  }
 }

 declare module '@mui/material/Chip' {
  interface ChipPropsVariantOverrides {
    largeText: true;
  }
}

// フォントサイズ計算用のスケール係数（現在は未使用）
const scaleFactor = 1 / 1.5;
const theme = createTheme({
   palette:{
      primary:{
          main:'#2196f3',//ブランドカラー(ブルー)
      },
      secondary:{
         main: '#f5f5f5',//薄いグレー
      },
      custom: {
         lightBlue: 'rgba(41, 121, 255, 0.1)',  // 薄い青色
         lightGreen: 'rgba(144, 238, 144, 0.5)', // 薄いグリーン
         lightPink: 'rgba(255, 182, 193, 0.5)',  // 薄いピンク
         lightOrange: 'rgba(255, 165, 0, 0.5)',  // 薄いオレンジ
         lightRed: 'rgba(255, 99, 71, 0.5)',     // 薄い赤色
         blue:'rgba(173, 216, 230, 1)',//グリーンに近いブルー
         gray:'#666666',//グレー
         bluePinkGradient: 'linear-gradient(to right, rgba(173, 216, 230, 0.5), rgba(255, 182, 193, 0.5))', // 透明なブルーとピンクの混ぜ色（著作権情報）
         bluePinkGradient2: 'linear-gradient(90deg, #2196f3 80%, #ffb6c1 100%)', // ブルーとピンクの混ぜ色（AppBar）
        //  lightbluePinkGradient: 'linear-gradient(to right, rgba(173, 216, 230, 0.2), rgba(255, 182, 193, 0.1))', // 超透明なブルーとピンクの混ぜ色（メモリー）
         lightbluePinkGradient: 'linear-gradient(to right, rgb(238, 247, 250), rgb(255, 247, 248))', // 超透明なブルーとピンクの混ぜ色を不透明な白で合成した色（メモリー）
       },
   },
  
    typography:{
        fontFamily:'游ゴシック, sans-serif',
        h1:{
           fontSize:'2.25rem',
          //  '@media (max-width:600px)': {
          //   fontSize: '1.3rem',
          // },
           fontWeight:'bold',
           color:'#333333', // 濃いグレー(ウェブサイトの名前)
           
        },
        h2:{
            fontSize:'1.7rem',
            // '@media (max-width:600px)': {
            //   fontSize: '1.2rem',
            // },
            fontWeight:'bold',
            color:'#333333', // 濃いグレー(機能モデルの見出し（XX一覧）)
         },
         h3:{
            fontSize:'1.3rem',
            // '@media (max-width:600px)': {
            //   fontSize: '1rem',
            // },
            fontWeight:'bold',
            color:'#333333', // 濃いグレー(小見出し、ニュース・メニューの見出し)
         },
        h4:{
          fontSize:'1rem',
          // '@media (max-width:600px)': {
          //   fontSize: '0.9rem',
          // },
          color:'#666666', //グレー          
         },
         h5:{
          fontSize:'1rem',
          // '@media (max-width:600px)': {
          //   fontSize: '0.9rem',
          // },
          color:'#FFFFFF', // 白
         },
         h6:{
            fontSize:'1rem',
            // '@media (max-width:600px)': {
            //   fontSize: '0.9rem',
            // },
            color:'#666666',            
           },

        
         body1:{
            fontSize:'1.1rem',
            // '@media (max-width:600px)': {
            //   fontSize:'1rem',
            // },
            color:'#333333', // 濃いグレー(通常の本文)
         },
         body2:{
            fontSize:'1.05rem',
            // '@media (max-width:600px)': {
            //   fontSize:'0.9rem',
            // },
            color:'#666666', // グレー（灰色の本文）
         },
         caption:{
          fontSize:'1.2rem',
          // '@media (max-width:600px)': {
          //   fontSize: '0.9rem',
          // },
         },
         subtitle1:{
          fontSize:'1rem',
          // '@media (max-width:600px)': {
          //   fontSize: '0.9rem',
          // },
        },
        button: {
          fontSize: '1rem', // デフォルトの Button
          // '@media (max-width:600px)': {
          //   fontSize: '0.9rem',
          // },
        },
        buttonMedium: {
          fontSize: '1.1rem',
          // '@media (max-width:600px)': {
          //   fontSize: '0.9rem',
          // },
        },
                
    },
    

   //  mixins: {
   //     toolbar: {
   //        minHeight: '54px', // Drawerの<DrawerHeader>のデフォルト設定を上書きする
   //     },
   //  },
   components: {
   MuiAccordionSummary: {
     styleOverrides: {
       root: {
         backgroundColor: '#f5f5f5', // 背景色の設定
         maxHeight: '25px', // 高さの設定
         minHeight: '25px', // 省略可能（rootクラスと同じ）
         '&.Mui-expanded': {
          maxHeight: '25px', // 展開時に高さを維持
          minHeight:'25px',
        },
       },
     },
   },
    MuiChip: {
      styleOverrides: {
        root: {
          fontSize: "1rem",
          // "@media (max-width:600px)": {
          //   fontSize: "0.9rem",
          // },
        },
      },
      variants: [
        {
          props: { variant: "largeText" },
          style: {
            fontSize: "1.2rem",
            // "@media (max-width:600px)": {
            //   fontSize: "1rem",
            // },
          },
        },
        // {
        //   props: { variant: "outlined" },
        //   style: {
        //     "& .MuiChip-label": {
        //       fontSize: "1rem",
        //       "@media (max-width:600px)": {
        //         fontSize: "0.9rem",
        //       },
        //     },
        //   },
        // },
      ],
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: "1rem", // TextFieldの入力文字サイズ
          // '@media (max-width:600px)': {
          //   fontSize: '0.9rem',
          // },
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        textarea: {
          fontSize: "1rem",   // 通常の<textarea>に反映
          // '@media (max-width:600px)': {
          //   fontSize: '0.9rem',
          // },
        },
        '.react-resizable-handle': {
          width: '20px',
          height: '20px',
          backgroundColor: 'Gray',
          position: 'absolute',
          bottom: 0,
          right: 0,
          cursor: 'ns-resize',
          zindex: 10,
          boxshadow: '0 0 4px rgba(0,0,0,0.3)',
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontSize: "1rem",          // ラベルのフォントサイズ
          // '@media (max-width:600px)': {
          //   fontSize: '0.9rem',
          // },
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          // '@media (max-width:600px)': {
          //   fontSize: '0.9rem',
          // },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          // '@media (max-width:600px)': {
          //   fontSize: '0.9rem',
          // },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head:({
          fontSize:"1.05rem",
          // '@media (max-width:600px)': {
          //   fontSize: '1rem',
          // },
        }),
        body: {
          fontSize: "1rem",
          // '@media (max-width:600px)': {
          //   fontSize: '0.9rem',
          // },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          // n文字以下は、ボタンの幅を固定幅にする。それ以外は、文字数に応じて可変にする。
          minWidth: 112, // 文字の大きさ1remの5文字分(全角かな)に相当する幅（開発者ツールで幅を確認しながら設定）
        },
      },
    },
  //  MuiAccordionDetails:{
  //   styleOverrides:{
  //     root:{
  //       maxHeight: '70px', // 高さの設定
  //       minHeight: '70px', // 省略可能（rootクラスと同じ）
  //     }
  //   }
  //  }
 },
});

export default theme;